import { MoneyCell } from '@ayocore/platform/client/components/EditableGrid';
import type { EditableGridColumn } from '@ayocore/platform/client/components/EditableGrid';
import type { WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey } from './types';

export const workOrderPriceColumn: EditableGridColumn<
  WorkOrderRow,
  WorkOrderPatch,
  WorkOrderColumnKey
> = MoneyCell<WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey>({
  key: 'price',
  title: 'Цена',
  width: 90,
  placeholder: '0',
  minValue: 0,
  precision: 2,
});
